import success from '../../../assets/images/successIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function TopUpSuccessPopup() {
  const dispatch = useAppDispatch();

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  return (
    <div className={styles.successPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.successTextWrapper}>
        <img src={success} alt="иконка успех" />
        <div style={{ width: '100%' }}>
          <h2 className={styles.successTitle}>Ваш баланс успешно пополнен!</h2>
        </div>
        <h3 className={styles.successSubTitle}>
          Средства будут зачислены в ближайшее время
        </h3>
      </div>
      <RedButton text="Хорошо" onClick={handleClosePopup} width={308} height={50} />
    </div>
  );
}

export default TopUpSuccessPopup;
